import React from "react";
import { CouponData } from "./interfaces";
import CouponAvailabilityIcon from "./CouponAvailabilityIcon";
import styled from "styled-components";
import moment from "moment";
import { ActionsType, CatalogGridItemProps } from "../../common/CatalogGrid/types";

const Item = styled.div`
    box-shadow: 0px 2px 4px 0px #00000040;
    cursor: pointer;

    & ${CouponAvailabilityIcon.Styled} {
        position: absolute;
        bottom: 0.25em;
        left: 0.25em;
        font-size: 1.5em;
    }
`;

const Thumb = styled.img`
    display: block;
    height: auto;
    width: 100%;
`;

const Availability = styled.div`
    background: #fff;
    color: #000;
    font-size: 0.65rem;
    padding: 0.75em 0.5em 0.5em 2.75em;
    text-transform: uppercase;
`;

function getDateString(str: string): string {
    const d = moment(str);
    return 'al ' + d.format('DD/MMM/YY').replace('.', '');
}

class CouponGridItem extends React.Component<CatalogGridItemProps> {
    render() {
        const coupon = this.props.item as CouponData;
        const {actions} = this.props;

        return <Item key={coupon.id} onClick={() => actions.onCouponClick(coupon)}>
            <Thumb src={coupon.thumb} alt={coupon.title} />
            <Availability>
                <CouponAvailabilityIcon color={coupon.status_color} />
                {getDateString(coupon.code ? coupon.redeem_date_limit : coupon.activation_date_limit)}
            </Availability>
        </Item>;
    }
}

export default CouponGridItem;